var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00008 0.5H14.0001C14.3537 0.5 14.6928 0.640476 14.9429 0.890524C15.1929 1.14057 15.3334 1.47971 15.3334 1.83333V11.1667C15.3334 11.5203 15.1929 11.8594 14.9429 12.1095C14.6928 12.3595 14.3537 12.5 14.0001 12.5H9.33341V11.1667H14.0001V1.83333H2.00008V3.83333H0.666748V1.83333C0.666748 1.47971 0.807224 1.14057 1.05727 0.890524C1.30732 0.640476 1.64646 0.5 2.00008 0.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33336 3.9165L-0.861084 6.74984L1.0278 7.77928V10.6126L4.33336 12.4165L7.63892 10.6126V7.77928L8.58336 7.26456V10.5276H9.5278V6.74984L4.33336 3.9165ZM7.55392 6.74984L4.33336 8.5065L1.1128 6.74984L4.33336 4.99317L7.55392 6.74984ZM6.69447 10.0554L4.33336 11.3398L1.97225 10.0554V8.294L4.33336 9.58317L6.69447 8.294V10.0554Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.0f9dad84.svg";
export { ForwardRef as ReactComponent };